// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2chhH","inner":"Form_inner__30hzW","range":"Form_range__34jbK","name":"Form_name__X3TQv","actions":"Form_actions__YpE6W"};